<template>
  <main class="app-get-step" id="mainContent">
    <div class="app-main-content">
      <div class="insuranceShowError app-alert-error app-system-alert" v-if="insuranceShowErrorMessage">
        <p>To continue with your duplicate title transaction you must certify that you are authorized to request a duplicate title.
          Please review your response below.
        </p>
      </div>
      <h1>Duplicate Title confirmation</h1>

      <div class="app-content-panels">
        <div class="app-panel-left">
          <div>
            <p>By checking "Yes" below, I certify that I am the registered owner of the vehicle or I am authorized by the registered owner to request a
              duplicate title for this vehicle.
            </p>
            <p>
              <strong> {{ year }} {{ make }} {{ model != 'UNKNOWN' ? model : '' }} {{ plateNumber }}<template v-if="plateNumber || plateType"> / {{ plateType }}</template> </strong>
            </p>
            <div class="app-input-group">
              <div class="app-input-selector">
                <input type="radio" id="yes" name="notify" v-model="insuranceInfo" value="yes" @change="insuranceError = false; insuranceShowErrorMessage = false">
                <label for="yes">Yes</label>
              </div>
              <div class="app-input-selector">
                <input type="radio" id="no" name="notify-no" v-model="insuranceInfo" value="no" @change="insuranceError = false">
                <label for="no">No</label>
              </div>
            </div>
          </div>
          <p class="app-error-message" v-if="insuranceError"> Response to this question is required. </p>
          <p id="app-error-message" class="sr-only" v-if="insuranceError"> Response to this question is required. </p>
          <BaseButtonGroup>
            <CustomButton @click="handleRouting(true)" class="resend-code">Previous</CustomButton>
            <CustomButton @click="handleRouting(false)">Next</CustomButton>
            <CustomButton v-if="!disableBtn" @click="getGoToProfile()" class="resend-code">Cancel and go to profile</CustomButton>
            <CustomButton :class="{ 'disabled': !disableBtn }" :aria-disabled="!disableBtn ? null: 'true'" @click="goToTxnCart(true)"
              v-if="disableBtn" class="resend-code">Cancel and go to cart
            </CustomButton>
          </BaseButtonGroup>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, computed, onMounted, toRefs} from 'vue'; 
import { useStore } from 'vuex'; 
import { useRouter } from 'vue-router';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import * as COMMONS from '../../store/_commons';
import CustomButton from '../../components/CustomButton.vue';

// Vuex store and router
const store = useStore();
const router = useRouter();

// Emits
const emit = defineEmits(['getStep']);

// Reactive data 
const stepNum = ref(2);
const screenData = ref({});
const insuranceInfo = ref('');
const insuranceShowErrorMessage = ref(false);
const insuranceError = ref(false);

// Reactive data ref 
const { year, make, model, plateNumber, plateType } = toRefs(store.state.guestLogin.selectRenewRegistartion);

const isBusinessUser = computed(() => store.state.guestLogin.isBusinessUser);
const profileRouteName = computed(() => {
  return isBusinessUser.value ? 'BusinessProfile' : 'Profile';
});

const disableBtn = computed(() => {
  let btn = false;
  if (store.state.guestLogin?.cartTransactions) { 
    btn = store.state.guestLogin.cartTransactions.cartTransactions.length > 1;
  }
  return btn;
});

// Actions 
const getSaveWipData = () => store.dispatch(COMMONS.GUEST_SAVEWIPDATA);
const getCancelTransaction = () => store.dispatch(COMMONS.GUEST_CANCELTRANSACTION);

// Methods
const handleRouting = async (isPrev = false) => {
  if (isPrev) {
    await getCancelTransaction();
    emit('getStep', 1);
    store.state.guestLogin.step = 1;
  } 
  else if (insuranceInfo.value === 'yes') { 
    await getSaveWipData();
  } 
  else if (insuranceInfo.value === 'no') {
    insuranceShowErrorMessage.value = true;
    // handle accessibility focus
    document.getElementById('mainContent').focus();
  } 
  else {
    insuranceError.value = true;
    // handle accessibility focus
    document.getElementById('mainContent').focus();
  }
};

const goToTxnCart = async () => {
  await getCancelTransaction();
  emit('getStep', 4);
  store.state.guestLogin.step = 4;
};

const getGoToProfile = async () => {
  await getCancelTransaction();
  router.push({ name: profileRouteName.value });
};

// Lifecycle hooks
onMounted(() => {
  window.scroll(0, 0);
  const mainContent = document.getElementById("mainContent");
  if (mainContent) {
    mainContent.focus();
  }
  // Set initial screen data, if needed
  screenData.value = store.state.STEPS[stepNum.value];
});
</script>

<style lang="scss" scoped>
.app-alert-error {
  display: block;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 28px;
  padding-left: 10px;
  padding-right: 10px;
}
.app-input-group {
  display: flex;
  margin-top: 0.5rem;
  gap: 2rem;
  .input-radio {
      min-width: 100px;
      input[type="radio"] {
      margin: 0.5em 0;
      }
  }
  label {
    margin-top: 0.65em;
  }
}

.app-modal-basic {
  overflow-y: auto;
  height: 300px;
}

.app-error-message {
  color: var(--ri-red);
  @extend %font-sans-regular;
  line-height: 1.35em;
  margin: unset;
  padding: 0.5em 0;
  &.--checker {
    margin-left: 1.5em;
  }
}
.insuranceShowError :deep(p) {
  font-size: 1rem;
  line-height: 1.5em;
  padding-top: .5em;
  padding-bottom: .5em;
}
.resend-code{
  background-color: white;
  color: var(--ri-blue);

  &:hover{
    background-color: var(--ri-lighter-blue);
    color: var(--ri-darker-blue);
  }
}
button {
  margin-bottom: 1.125em;
  &:not(:last-child) {
    margin-right: 1em;
  }
  &.disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
